import React, { useEffect, useState } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { FaEye } from 'react-icons/fa';

const FooterLayout: React.FC = ({ children }) => {


  const [quantity, setQuantity] = useState(15);


  useEffect(() => {
    // Função para gerar um número aleatório entre 12 e 25
    const getRandomNumber = () => Math.floor(Math.random() * (25 - 12 + 1)) + 12;
    setQuantity(getRandomNumber);
    // Atualiza a cada 60 segundos (60000 ms)
    const interval = setInterval(() => {
      const newQuantity = getRandomNumber();
      setQuantity(newQuantity);
    }, 10000);

    // Atualiza imediatamente ao montar também, se quiser
    // setQuantity(getRandomNumber());

    return () => clearInterval(interval);
  }, []);

  return (<><div style={{ zIndex: -1 }}>
    <Particles
      params={{
        particles: {
          lineLinked: {
            enable: false,
            distance: 250
          },
          move: {
            speed: 15,
            direction: window?.location?.pathname?.indexOf('/podcasts') >= 0 ? 'bottom' : 'top-right',
            collisions: false,
            outModes: {
              default: 'out',
              left: 'out',
              right: 'out',
              bottom: 'out',
              top: 'out',
            },


          },
          opacity: {
            value: 0.4,
            random: false,
            animation: {
              enable: false
            }

          },
          shape: {
            type: 'circle',
            polygon: {

              nb_sides: 6,

            },

          },

          color: { value: window?.location?.pathname?.indexOf('/podcasts') >= 0 ? '#f25930' : 'rgb(171, 230, 255)' },

          number: {
            density: {
              enable: true,
              value_area: 2400,
            },
            value: 60,
          },
          size: {
            value: window?.location?.pathname?.indexOf('/podcasts') >= 0 ? 10 : 2,
            random: true,
          },
        },
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 1
      }}
    />
    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}
    <div className='globalFooter' style={{ position: 'relative', alignItems: 'flex-end' }}>
      <div>
        <a href="/termos"><p>Política de privacidade</p></a>
        <a href="/politica"><p>Termos de cancelamento e reembolso</p></a>
      {/*  <Whatsapp text={`Olá, estou na Plataforma Everaldo Rodrigues`} message="Fale conosco" /> */}
      </div>
      <p style={{ fontSize: '12px', color: '#fff' }}>

        Desenvolvido por <a style={{ color: '#fff', fontWeight: 'bold' }} target="_BLANK" href="https://encontrodigital.com.br">https://encontrodigital.com.br</a>
      </p>
    </div>
  </div>
{/* <div className='row gap-sm' style={{display:'flex', zIndex: 1000000000, position:'fixed', bottom:0, left: 0, width: '100%', justifyContent:'center', flexWrap:'wrap', alignItems:'center', background: 'rgba(0, 250, 0,0.9)',padding: '15px', gap: '30px'}}>
<FaEye size={30} color='rgb(2, 28, 60)'/> <p style={{maxWidth:'400px', color: 'rgb(2, 28, 60)', fontSize:'18px', lineHeight:'18px'}}>{quantity} pessoas comprando neste momento</p>
 
</div> */}
  </>
  );
};

export default FooterLayout;
